(function () {
  'use strict';

  angular
    .module('app.account-saved-carts', [])

    .component('accountSavedCarts', {
      bindings: {
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountSavedCarts;
      }],
      /* @ngInject */
      controller: ["$scope", "$rootScope", "$element", "$location", "$timeout", "AccountService", "HttpService", "AppService", "ModalService", "RoutesService", "toastr", function ($scope, $rootScope, $element, $location, $timeout, AccountService, HttpService, AppService, ModalService, RoutesService, toastr) {
        var ctrl = this;

        AccountService.initAccount(ctrl);

        ctrl.$onInit = function () {
          $scope.device = ctrl.device;
          ctrl.loading = true;

          AppService.getParams()
            .then(function (params) {
              if (!params.Account.IsManagementWebCartTracking) {
                $location.path(ctrl.links.AccountHome);
              } else {
                loadData();
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        // Translate
        var tplTranslate = {};
        $element.children('.translate').children().each(function () {
          var $this = $(this);
          tplTranslate[$this.attr('key')] = $this.html();
        });

        ctrl.remove = function (idWebFolder) {
          $rootScope.$broadcast('showPageLoader', true);
          HttpService.post({
            url: 'AccountSavedCarts/Remove',
            data: {
              IDWebFolder: idWebFolder
            }
          })
          .then(function (response) {
            if (response.status === 'OK') {
              _.pullAllBy(ctrl.carts, [{ IDWebFolder: idWebFolder }], 'IDWebFolder');
              if (!ctrl.carts.length) {
                $rootScope.$broadcast('userUpdate');
                $location.path(ctrl.links.AccountHome);
              }
              toastr.success('', tplTranslate.removeOK, {
                allowHtml: true,
                extraData: {
                  template: 'toast_message.tpl'
                }
              });
            } else {
              AppService.getTranslate()
                .then(function (translate) {
                  toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                });
            }
            $rootScope.$broadcast('showPageLoader', false);
          })
          .catch(function (error) {
            console.error(error);
          });
        };

        ctrl.addAllToCart = function (cart) {
          $rootScope.$broadcast('showPageLoader', true);
          AppService.getParams()
            .then(function (params) {
              $rootScope.$broadcast('showPageLoader', false);
              var products = [];
              _.each(cart.WebFolderLines, function (line) {
                if (line.Product.AllowAddToCart) {
                  products.push({
                    idProduct: line.Product.IDProduct,
                    Price: AppService.getProductPrice(line.Product.Price, line.Quantity),
                    showTTCPrice: params.Visitor.CardType.ShowTTCPrice,
                    quantity: line.Quantity,
                    designation: line.Product.Designation,
                    img: line.Product.IDPicture,
                    URL: line.Product.URL
                  });
                }
              });

              ModalService.close();
              ModalService.show(
                '/Template/Modal/ModalAddToCart',
                products,
                null,
                'modalAddToCartCtrl',
                null,
                null,
                {
                  cartLink: '/' + RoutesService.getUrlByName('Cart')
                }
              );

              AppService.addToCart(products)
                .then(function (response) {
                  if (response.status === 'OK') {
                    AppService.updateParams(response.results);
                  } else {
                    AppService.getTranslate()
                      .then(function (translate) {
                        toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                          allowHtml: true,
                          extraData: {
                            template: 'toast_message.tpl'
                          }
                        });
                      });
                  }
                })
                .catch(function (error) {
                  console.error(error);
                });
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        function loadData() {
          HttpService.get({
            url: '/AccountSavedCarts/Get',
            cache: false
          })
          .then(function (response) {
            ctrl.carts = response.results.carts;
            _.each(ctrl.carts, function (cart) {
              cart.addAllEnabled = true;

              _.each(cart.WebFolderLines, function (line) {
                getCustom(line);
                if (!line.Product.AllowAddToCart) {
                  cart.addAllEnabled = false;
                }
              });
              $timeout(function () {
                cart.init = true;
              }, 350);
            });
            $timeout(function () {
              ctrl.carts[0].isOpen = true;
            }, 1000);

            ctrl.loading = false;
          })
          .catch(function (error) {
            console.error(error);
          });
        }

        function getCustom(line) {
          if (line.Product.Customization) {
            _.each(line.Product.Customization.Items, function (item) {
              if (!item.Group) {
                if (item.Field.Value && item.Field.Code === 'DateEnvoi') {
                  item.Field.Value = item.Field.Value.split('T')[0];
                }
              }
              if (item.Group) {
                _.each(item.Group.Fields, function (field) {
                  if (field.Value && field.Code === 'DateEnvoi') {
                    field.Value = field.Value.split('T')[0];
                  }
                });
              }
            });
          }
        }
      }],
      controllerAs: 'accountCtrl'
    });

})();
